import { gql } from "@apollo/client";

export const SEND_CREDIT_NOTE_MAIL = gql`
  mutation sendCreditNote($id: String!, $additionalMails: [String]) {
    sendCreditNote(id: $id, additionalMails: $additionalMails)
  }
`;